import React from 'react';
import { ArrowRight, LockKeyhole } from 'lucide-react';
import { motion } from 'framer-motion';
interface HeroSectionProps {
  isPortfolioUnlocked: boolean;
  onRequestPortfolioAccess: () => void;
}
export function HeroSection({
  isPortfolioUnlocked,
  onRequestPortfolioAccess
}: HeroSectionProps) {
  return <section id="home" className="w-full overflow-hidden bg-dark pb-24 pt-44 font-inter text-base leading-[30px] text-white/65 md:pb-32 md:pt-52" data-id="element-103" data-mp="28v62b2o8il8f">
      <div className="mx-auto max-w-[1320px] px-4" data-id="element-104" data-mp="30lasxj2l84i3">
        <div className="relative mx-auto max-w-5xl text-center" data-id="element-105" data-mp="30ksq23lf6s17">
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="mb-5 font-inter text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-106" data-mp="2mufjo5o6fldz">
            Byteweb · Cape Town digital studio
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.08
        }} className="mb-7 font-syne text-5xl font-bold leading-[1.02] text-white md:text-7xl lg:text-8xl" data-id="element-107" data-mp="2fg1sb5vnho1y">
            Digital products built for{' '}
            <span className="relative inline-block text-gold" data-id="element-108" data-mp="2u4ohdzb2xu6d">
              meaningful momentum.
              <svg className="absolute -bottom-2 left-0 h-3 w-full text-gold" viewBox="0 0 100 10" preserveAspectRatio="none" aria-hidden="true" data-id="element-109" data-mp="383xrch8ozs1w">
                <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="2" fill="none" data-id="element-110" data-mp="1dr7rzjzk1qn4" />
              </svg>
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.16
        }} className="mx-auto max-w-2xl text-lg leading-relaxed text-white/65 md:text-xl" data-id="element-111" data-mp="38vo02qs7zlbl">
            Byteweb partners with ambitious organisations to clarify strategy,
            create distinctive digital experiences, and build websites that
            perform long after launch.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.24
        }} className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-112" data-mp="5eytj4sn0blx">
            <a href="#contact" className="inline-flex items-center justify-center rounded border border-true-black bg-gold px-8 py-4 font-inter text-base font-bold text-true-white shadow-[4px_4px_0px_0px_#fff,4px_4px_0px_1px_#000] transition-all duration-300 hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_#fff,6px_6px_0px_1px_#000] focus:outline-none focus:ring-2 focus:ring-gold" data-id="element-113" data-mp="23sbr68x1ozc1">
              Start a conversation
              <ArrowRight className="ml-2 h-[18px] w-[18px]" data-id="element-114" data-mp="2iklxb20qfzea" />
            </a>

            {isPortfolioUnlocked ? <a href="#private-profile" className="inline-flex items-center justify-center rounded border border-white px-8 py-4 font-inter text-base font-bold text-white transition-colors hover:border-gold hover:text-gold focus:outline-none focus:ring-2 focus:ring-gold" data-id="element-115" data-mp="2dqrh48kc62jy">
                View professional profile
                <ArrowRight className="ml-2 h-[18px] w-[18px]" data-id="element-116" data-mp="2l2e71v5s11i0" />
              </a> : <button type="button" onClick={onRequestPortfolioAccess} className="inline-flex items-center justify-center rounded border border-white px-8 py-4 font-inter text-base font-bold text-white transition-colors hover:border-gold hover:text-gold focus:outline-none focus:ring-2 focus:ring-gold" data-id="element-117" data-mp="2q20jw3hp0fqa">
                <LockKeyhole className="mr-2 h-[18px] w-[18px]" data-id="element-118" data-mp="38s8iq9ed0k0o" />
                Client access
              </button>}
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.38
        }} className="mx-auto mt-16 grid max-w-3xl grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-3" data-id="element-119" data-mp="2v0bw2kvgn2bo">
            {[['Strategy', 'Clear direction before design'], ['Experience', 'Interfaces made for real people'], ['Technology', 'Reliable builds with room to grow']].map(([title, detail]) => <div key={title} className="bg-dark px-5 py-5 text-left" data-id="element-120" data-mp="afvadnfm3qn0">
                <p className="font-syne text-base font-bold text-white" data-id="element-121" data-mp="aipwdje9xjij">
                  {title}
                </p>
                <p className="mt-1 text-sm leading-relaxed text-white/50" data-id="element-122" data-mp="3euv4xeg29xdt">
                  {detail}
                </p>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}